jQuery(document).ready(function($) {
	$( '.home-slider' ).sliderPro({
		width: 1140,
		height: 626,
		arrows: true,
		buttons: false,
		waitForLayers: true,
		thumbnailWidth: 228,
		thumbnailHeight: 100,
		thumbnailPointer: true,
		autoplay: true,
		autoScaleLayers: false,
		breakpoints: {
			1024: {
				thumbnailWidth: 250,
				thumbnailHeight: 100
			},
			849: {
				thumbnailWidth: '100%',
				thumbnailHeight: 150
			},
			780: {
				thumbnailWidth: '100%',
				thumbnailHeight: 100
			},
			540: {
				thumbnailWidth: '100%',
				thumbnailHeight: 200
			},
			420: {
				thumbnailWidth: '100%',
				thumbnailHeight: 150
			}
		}
	});
	
	$( '.article-slider' ).sliderPro({
		width: 814,
		height: 446,
		arrows: true,
		buttons: false,
		waitForLayers: true,
		thumbnailWidth: 326,
		thumbnailHeight: 80,
		thumbnailPointer: false,
		thumbnailsPosition: 'right',
		autoplay: false,
		autoScaleLayers: false,
		orientation: 'horizontal',
		breakpoints: {
			1024: {
				thumbnailWidth: 300,
				thumbnailHeight: 80
			},
			849: {
				thumbnailWidth: '100%',
				thumbnailHeight: 40
			},
			780: {
				thumbnailsPosition: 'bottom',
				thumbnailWidth: '100%',
				thumbnailHeight: 40
			},
			540: {
				thumbnailsPosition: 'bottom',
				orientation: 'horizontal',
				thumbnailWidth: '100%',
				thumbnailHeight: 80
			},
			420: {
				thumbnailsPosition: 'bottom',
				thumbnailWidth: '100%',
				thumbnailHeight: 80
			}
		}
	});
	
	$( '.article-slider' ).on( 'gotoSlide', function( event ) {
		console.log( event.index );
		$(".slide-content").css("display","none");
		$(".slide-content-" + event.index).css("display","block");
	});

	$( ".next-btn" ).click(function() {
	  $( '.article-slider' ).sliderPro( 'nextSlide' );
	  	$("html, body").animate({ scrollTop: 0 }, "fast");
  		return false;
	});

	setTimeout(function(){
	    $('.home-slider').show(); 
	}, 100);

	toggleSearch();
	function toggleSearch() {
		if($(window).width()<850)
		{
			$('#header .header-search .is-small').show();
			// $('#header .header-search .nav-dropdown').hide();
			$('#header .header-search .is-small').click(function() {
				$('#header .header-search .nav-dropdown').toggle();
				$('.search-field').focus();
			});
		}
		else
		{
			$('#header .header-search .is-small').hide();
			// $('#header .header-search .nav-dropdown').show();
		}
	} 
	
	$( "#exit-search" ).click(function() {
		$('ul.nav-dropdown.nav-dropdown-default').hide();
	});
	
	jQuery(document).ready(function($) {
		$('a')
			.filter('[href^="http"], [href^="//"], [href^="https"]')
			.not('[href*="' + window.location.host + '"]')
			.attr('rel', 'noopener noreferrer')
			.attr('target', '_blank');
	});
	
	jQuery('.gallery').flickity({
	  // options
	    cellAlign: "center",
		imagesLoaded: true,
		lazyLoad: 1,
		freeScroll: false,
		wrapAround: true,
		autoPlay: false,
		pauseAutoPlayOnHover : true,
		prevNextButtons: true,
		contain : false,
		adaptiveHeight : true,
		dragThreshold : 5,
		percentPosition: true,
		pageDots: true,
		rightToLeft: false,
		draggable: true,
		selectedAttraction: 0.1,
		parallax : 0,
		friction: 0.6
	});

	if(jQuery('.block-post-head').length > 0){
		if(jQuery('.block-post-head .block').length > 0){
			var maxHeightNameDesc = 0;
			jQuery('.block-post-head .block').each(function(){
				if(jQuery(this).height() > maxHeightNameDesc){
					maxHeightNameDesc = jQuery(this).height();
				}
			});
			if(maxHeightNameDesc > 0){
				jQuery('.block-post-head .block').height(maxHeightNameDesc);
			}
			jQuery(window).resize(function(){
				if(jQuery(window).width() > 849) {
					jQuery('.block-post-head .block').css('height','');
					var maxHeightNameDesc = 0;
					jQuery('.block-post-head .block').each(function(){
						if(jQuery(this).height() > maxHeightNameDesc){
							maxHeightNameDesc = jQuery(this).height();
						}
					});
					if(maxHeightNameDesc > 0){
						jQuery('.block-post-head .block').height(maxHeightNameDesc);
					}
				} else {
					jQuery('.block-post-head .block').height('auto');
				}
			});
		}
	}

});

jQuery(window).load( function() {
	//jQuery('.wp-caption').append('<div class="img-overlay"></div>');
});

/*
jQuery('.leaderboard, .header-skin').each(function() {
	if (jQuery(this).find('img, iframe').length) {
		
	} else {
		jQuery(this).hide();
	}
});
*/

jQuery(function($) { 
	
	jQuery('.gallery').on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
	  // dismiss if cell was not clicked
	  var imagelink = jQuery(cellElement).find("img").attr("src");
	  window.open(imagelink, '_blank'); 
	});
	$('figure img').each( function() {
		var $img = $(this),
			href = $img.attr('src');
		$img.wrap('<a href="' + href + '" target="_blank" class="link"></a>');
	});
	$(function(){
		var iframe = $('.cvm-player > iframe')[0],
			player = $f(iframe),
			status = $('.status');
	
	// When the player is ready, add listeners for pause, finish, and playProgress
		player.addEvent('ready', function() {
			status.text('ready');

		});
	
	  // Call the API when a button is pressed
		$(window).scroll(function() {
			$('.cvm-player').each(function() {
				if ($(this).visible(true)) {
					player.api('play');
					player.api('setVolume', 0);
				} else {
					player.api('pause');
					player.api('setVolume', 0);
				}
			})
		});

	});
});